import { render, staticRenderFns } from "./UploadFingerprintSingle.vue?vue&type=template&id=aadaa282&scoped=true&"
import script from "./UploadFingerprintSingle.vue?vue&type=script&lang=js&"
export * from "./UploadFingerprintSingle.vue?vue&type=script&lang=js&"
import style0 from "./UploadFingerprintSingle.vue?vue&type=style&index=0&id=aadaa282&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aadaa282",
  null
  
)

export default component.exports